import { token, domain } from "../../../../../components/Security";
import axios from "../../../../../api/apiClient";
import { useCallback, useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { ReferenceFilter } from "./ReferenceFilter";
import { CreateSearchBarWithPlaceHolder } from "../../../../../components/CommonObjects";
import { CreateTableForReferenceSelect } from "./CreateTableForReferenceSelect";
import { ViewLeaveForm } from "./ViewLeaveForm";


export function ReferenceSelectForm({
	isOpen,
	onClose,
	setReference,
	setReferenceId,
	setAdjustmentDate,
}) {
	var header = [
		"Reference No.",
		"Employee",
		"Request Date",
		"Request",
		"Status",
		"",
	];
	var accessor = [
		"referenceNumber",
		"employeePersonalInformationFullName",
		"dateRequested",
		"requestTypeDescription",
		"status",
		"manage",
	];

	const [viewData, setViewData] = useState([]);
	const [showViewData, setShowViewData] = useState(false);
	const [data, setData] = useState([]);
	const [selectedReference, setSelectedReference] = useState([]);
	const [filterData, setFilterData] = useState([]);
	const [filterDataIndex, setFilterDataIndex] = useState(0);
	const [searchPlaceholder, setSearchPlaceholder] = useState(
		"Search by reference id"
	);

	const handleClose = () => {
		onClose();
		fetchData();
	};
	const handleProceed = () => {
		onClose();
		if (selectedReference.length !== 0) {
			setReference(selectedReference);
			setReferenceId(selectedReference.referenceNumber);
			setAdjustmentDate(selectedReference.dateRequested);
		}
		fetchData();
	};
	const viewHandleClick = (data) => {
		setViewData(data);
		setShowViewData(true);
	};
	const closeViewHandleClick = () => {
		setShowViewData(false);
	};

	const fetchData = useCallback(async () => {
		const leaves = await fetchDataLeave();
		const ot = await fetchDataOvertime();

		const combinedData = [...leaves, ...ot];

		setData(combinedData);
		setFilterData(combinedData);
	}, []);

	const fetchDataLeave = async () => {
		const apiUrl = `${domain}/api/LeaveRequest/days-range/30`;

		try {
			const response = await axios.get(apiUrl, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			});

			const filteredDatas = response.data.filter(
				(filteredData) => filteredData.status === "Approved"
			);

			return filteredDatas;
		} catch (error) {
			console.error("Error fetching leave data:", error);

			return [];
		}
	};

	const fetchDataOvertime = async () => {
		const apiUrl = `${domain}/api/OvertimeRequest/days-range/30`;

		try {
			const response = await axios.get(apiUrl, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			});

			const filteredDatas = response.data.filter(
				(filteredData) => filteredData.status === "Approved"
			);
			return filteredDatas;
		} catch (error) {
			console.error("Error fetching leave data:", error);

			return [];
		}
	};

	const handleFilter = (value) => {
		const lowercaseValue = value.toLowerCase();
		var res = [];

		switch (filterDataIndex) {
			case 0:
				res = filterData.filter((f) =>
					f.referenceNumber.toString().startsWith(lowercaseValue)
				);
				break;
			case 1:
				res = filterData.filter((f) =>
					f.employeePersonalInformationFullName
						.toLowerCase()
						.includes(lowercaseValue)
				);
				break;
			default:
				res = filterData.filter((f) =>
					f.referenceNumber.toString().startsWith(lowercaseValue)
				);
				break;
		}

		setData(res);
	};

	useEffect(() => {
		switch (filterDataIndex) {
			case 0:
				setSearchPlaceholder("Search by reference id");
				break;
			case 1:
				setSearchPlaceholder("Search by employee");
				break;
			default:
				setSearchPlaceholder("Search by reference id");
				break;
		}
		fetchData();
	}, [fetchData, filterDataIndex]);

	return (
		<>
			<div className={`modal-overlay ${isOpen ? "open" : ""}`}>
				{isOpen && (
					<div className="modal">
						<div className="popUp-header row">
							<div className="popUp-title">
								<h3 style={{ color: "#668fca" }}>Select Reference Id</h3>
							</div>
							<div className="popUp-close">
								<CloseIcon onClick={() => handleClose()} />
							</div>
						</div>
						<div className="transaction-body">
							<ReferenceFilter setFilterDataIndex={setFilterDataIndex} />
							<div className="transaction-body-top row">
								{CreateSearchBarWithPlaceHolder(
									"",
									"transaction-search row",
									"transaction-search-icon",
									"transaction-search-input",
									(e) => handleFilter(e.target.value),
									searchPlaceholder,
									SearchIcon
								)}
							</div>
						</div>
						<div className="popUp-body selectModal">
							<div className="select-employee-table">
								<CreateTableForReferenceSelect
									dataList={data}
									dataHeader={header}
									dataAccessor={accessor}
									setSelectedReference={setSelectedReference}
									viewHandleClick={viewHandleClick}
								/>
								{data.length > 0 ? (
									<div></div>
								) : (
									<div> {/*<p>No records to display</p>*/}</div>
								)}
							</div>
						</div>
						<div
							className="buttons row"
							style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
						>
							<button
								id="add-family"
								className="save row"
								onClick={handleProceed}
							>
								PROCEED
							</button>
						</div>
					</div>
				)}
			</div>
			<ViewLeaveForm
				isOpen={showViewData}
				onClose={closeViewHandleClick}
				viewData={viewData}
			></ViewLeaveForm>
		</>
	);
}